import { VatBadge } from "../../common/footer/VatBadge";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { isFlyin } from "@/src/utils/generalUtils/isFlyin";


export const CopyRight = () => {
    const flyin = isFlyin();
    const t = useTranslations('footer')


    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 3, py: 2 }}>
            { flyin ?
                <>
                    <VatBadge size={32} />
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', fontWeight: 400 }}>
                        {t('copyright', { year: new Date().getFullYear() })}
                    </Typography>
                </>
                :
                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px', fontWeight: 400 }}>
                    {t('copyrightCleartrip', { year: new Date().getFullYear() })}
                </Typography>

            }
        </Box>
    )
}